/**
 * Return a timestamp in miliseconds to store in the revision.
 */
export function getTimestamp(): number {
    return Date.now();
}
